import { isQuiet } from '../../../shared/heartbeat'
import './scene-status.component.less'

/**
 * The dot is read again this often. The limit is in shared/heartbeat.js, and
 * this poll is shorter than it, so the dot turns red soon after the limit.
 */
const POLL_MS = 10000

class SceneStatusController {
  constructor ($scope, $interval, SceneService) {
    'ngInject'

    this._$scope = $scope
    this._$interval = $interval
    this._SceneService = SceneService
    this.isCollapsed = false
    this.isOnline = false
  }

  $onInit () {
    this.unsubscribe = this._SceneService.subscribeToId(this.id, scene => {
      this.scene = scene
      this._updateOnlineStatus()
    })

    this._statusInterval = this._$interval(() => this._updateOnlineStatus(), POLL_MS)

    this._$scope.$on('$destroy', () => {
      this.unsubscribe()
      if (this._statusInterval) {
        this._$interval.cancel(this._statusInterval)
      }
    })
  }

  _updateOnlineStatus () {
    if (!this.scene || !this.scene.lastSeen) {
      this.isOnline = false
      return
    }
    // The play report reads the same rule from shared/heartbeat.js, so one
    // screen never gets two answers.
    this.isOnline = !isQuiet(this.scene.lastSeen, Date.now())
  }
}

export default {
  bindings: {
    id: '<'
  },
  controller: SceneStatusController,
  template: require('./scene-status.component.html').default
}
